<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center mt-5 m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="mt-5">
            <CCard
              v-for="item in quizList"
              v-bind:key="item.subjectId"
              style="background: #ebedef; border: 1px solid #009688"
              body-wrapper
              text-color="black"
              class="box-shadow"
              @click="GoToPageQuizList(item.subjectId)"
            >
              <div class="text-center">
                <h5 class="ml-2 mr-2">Subject : {{ item.subjectName }}</h5>
              </div>
              <CRow>
                <!-- Image subject -->
                <div class="col-4 text-center">
                  <div v-if="item.subjectName == 'Mathematics'">
                    <img src="../assets/img/maths.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Additional Mathematics'">
                    <img src="../assets/img/iconaddmath.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Science'">
                    <img src="../assets/img/science.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Physics'">
                    <img src="../assets/img/physics.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Chemistry'">
                    <img src="../assets/img/chemistry.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Biology'">
                    <img src="../assets/img/iconbiology.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Sejarah'">
                    <img src="../assets/img/iconhistory.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Geografi'">
                    <img src="../assets/img/icongeography.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Information and Communication Technology'">
                    <img src="../assets/img/iconit.png" width="50px" class="mt-3" />
                  </div>
                  <div v-else-if="item.subjectName == 'Bahasa Inggeris'">
                    <img src="../assets/img/iconenglish.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Additional Science'">
                    <img src="../assets/img/addscience.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Prinsip Perakaunan'">
                    <img src="../assets/img/iconaccount.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Literature in English'">
                    <img src="../assets/img/iconliterature.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Bahasa Melayu'">
                    <img src="../assets/img/iconbm.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Pendidikan Islam'">
                    <img src="../assets/img/iconislamic.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Bahasa Arab'">
                    <img src="../assets/img/iconarab.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else-if="item.subjectName == 'Perniagaan'">
                    <img src="../assets/img/iconbusiness.png" width="50px" class="mt-3" />
                  </div>

                  <div v-else>
                    <img src="../assets/img/iconsub.png" width="50px" class="mt-3" />
                  </div>
                </div>
                <!-- END image -->

                <div class="col-8">
                  <br />
                  Total Quiz : {{ item.totalQuizCount }} Quiz
                  <br />
                  Quiz Publish : {{ item.publishCount }} Quiz
                  <br />
                  Quiz Pending : {{ item.pendingCount }} Quiz
                </div>
              </CRow>
              <br />
              <br />
              <CCard body-wrapper class="bottom-center m-0" style="background-color: #40E0D0;">
                <div class="bottom-view-right">
                  <strong>View</strong> &nbsp;
                  <CIcon name="cil-chevron-right" />
                </div>
              </CCard>
            </CCard>

            <!-- </CRow>
              <br /><br />
              <CCard
                body-wrapper
                class="bottom-center m-0"
                style="background-color: #80dfff;"
              >
                <div class="bottom-icon-left">
                  <CIcon name="cil-trash" width="25px" height="25px" />
                </div>
                <div class="bottom-view-right">
                  View &nbsp; <CIcon name="cil-chevron-right" />
                </div>
              </CCard>
            </CCard>-->

            <!-- button add subject -->
            <!-- <div class="mt-4">
                <CButton
                  color="success"
                  class="custom-btn"
                  block
                  @click="GoToPageCreateTitle()"
                  >Create Quiz</CButton>
            </div>-->

            <div class="mt-4">
              <CButton
                class="circle-button-float text-white float-right mb-4"
                style="font-size:11px;"
                @click="GoToPageCreateTitle()"
              >
                <CIcon name="cil-plus" height="25px" />
                <br />Create Quiz
              </CButton>

           
            </div>

         
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebTutor.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      quizList: [],
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false
    };
  },
   async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
       this.GetQuizDetails();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},
  methods: {
     SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetQuizDetails(this.user.id);
          }
        });
    },
    async GetQuizDetails() {
      this.$API
        .get(this.$QuizTeacherDetails + "?userId=" + this.user.id, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.quizList = response.data;
          }
        });
    },
    GoToPageQuizList(subjectId) {
      this.$router.push(
        "/QuizTeacherQuizList?userId=" +
          this.user.id +
          "&subjectId=" +
          subjectId
      );
    },
    GoToPageCreateTitle() {
      this.$router.push(
        "/QuizTeacherCreateTitle?userId=" + this.user.id
      );
    }
  }
};
</script>
<style>
#fb-root{
  display:none;
}
</style>